import Image from "next/image";

// Glassmorphism pill badge with a sparkle — first used as the Hero's
// "At Celestial Code" eyebrow, now shared as the standard section eyebrow
// (e.g. "Portfolio Preview"). Presentational only; wrap in a motion element if
// you want an entrance animation.
export default function Badge2026({ children, className = "" }) {
  return (
    <div
      className={`inline-flex items-center gap-2.5 rounded-[16px] border border-white/20 bg-white/20 px-3 py-2.5 shadow-[inset_0px_4px_4px_0px_rgba(255,255,255,0.1)] backdrop-blur-[10px] ${className}`}
    >
      <span className="text-base text-white">{children}</span>
      <Image
        src="/images/2026/hero/badge-sparkle-square.svg"
        alt=""
        width={32}
        height={32}
        className="h-8 w-8"
      />
    </div>
  );
}
